import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';

const actions = {
  async getPagesHelpCenter({ commit }, page) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.pageHelpCenter,
        params: { page },
        isToken: true,
      });
      commit('GET_HELP_CENTERS_SUCCESS', data);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async createHintPageHelpCenter({ dispatch, state }, body) {
    try {
      await apiCall({
        type: 'POST',
        url: URLS.pageHelpCenter,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Hint updated');
      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async editHintPageHelpCenter({ dispatch, state }, payload) {
    const { id, ...body } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.pageHelpCenter}/${id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Hint updated');
      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deletePageHelpCenter({ dispatch, state }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.pageHelpCenter}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Hint deleted');
      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async getCategoriesHelpCenter({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.pageHelpCenterCategories,
        isToken: true,
      });
      commit('GET_HELP_CENTERS_CATEGORIES_SUCCESS', data);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async createCategoriesHelpCenter({ dispatch, state }, body) {
    try {
      await apiCall({
        type: 'POST',
        url: URLS.pageHelpCenterCategories,
        body,
        isToken: true,
      });
      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
      dispatch('getCategoriesHelpCenter');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async editCategoriesHelpCenter({ dispatch, state }, payload) {
    const { categoryId, ...body } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.pageHelpCenterCategories}/${categoryId}`,
        body,
        isToken: true,
      });
      dispatch('getCategoriesHelpCenter');
      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteCategoriesHelpCenter({ dispatch, state }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.pageHelpCenterCategories}/${id}`,
        isToken: true,
      });

      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
      dispatch('getCategoriesHelpCenter');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async changePositionHelpCenter({ dispatch, state }, body) {
    try {
      await apiCall({
        type: 'PUT',
        url: URLS.pageHelpCentersPosition,
        body,
        isToken: true,
      });
      dispatch('getPagesHelpCenter', state?.pageHelpCenter?.page);
      dispatch('getCategoriesHelpCenter');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
